import { MessageCircle } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function WhatsAppFloat() {
  const { content, ui } = useSite();
  const wa = `https://wa.me/${content.whatsapp}?text=${encodeURIComponent(ui.whatsappMsg)}`;

  return (
    <a
      data-testid="whatsapp-float"
      href={wa}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)] transition-transform hover:scale-110"
    >
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-25" />
      <MessageCircle size={26} className="relative" />
    </a>
  );
}
